import { render, staticRenderFns } from "./complications.vue?vue&type=template&id=8fbfc7b8&scoped=true&"
import script from "./complications.vue?vue&type=script&lang=js&"
export * from "./complications.vue?vue&type=script&lang=js&"
import style0 from "./complications.vue?vue&type=style&index=0&id=8fbfc7b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbfc7b8",
  null
  
)

export default component.exports